module.exports = __webpack_public_path__ + "media/src/components/GenerateDocument/images/loading-circle-c61fb3dfd776c2290fc166c84abbcfb2.png";